<template>
  <div :class="['modal', 'animated', show ? 'is-active' : '']">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div>
          To reset your password, type the full email address you used to sign up and we'll send you an e-mail to walk you through resetting your password.
        </div>
        <br>
        <div class="notification is-danger" v-if="error">{{error}}</div>
        <div class="notification is-success" v-if="success">{{success}}</div>
        <p :class="{'control': true, 'has-icon': true, 'is-loading': inProgress, 'is-danger': errors.has('email')}">
          <input name="email" id="email" class="input" type="email" placeholder="Email" v-model="form.email" v-validate data-vv-rules="required|email">
          <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
          <i class="fa fa-envelope"></i>
        </p>
      </section>
      <footer class="modal-card-foot">
        <a :class="{'button': true, 'is-warning': true, 'is-disabled': inProgress}" style="float: right;" @click="send">Send</a>
        <a :class="{'button': true, 'is-primary': true}" style="float: right;margin-right: 10px;" @click="back">Back</a>
      </footer>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      card: Boolean,
      visible: Boolean
    },
    data () {
      return {
        show: true,
        title: 'Forgot Password?',
        form: {
          email: ''
        },
        error: null,
        success: null,
        inProgress: false
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
      })
    },
    created () {

    },
    destroyed () {
      this.$el.remove()
    },
    methods: {
      afterLeave () {
        this.$destroy()
      },
      active () {
        this.show = true
      },
      deactive () {
        this.show = false
      },
      close () {
        this.deactive()
      },
      open () {
        this.active()
      },
      send () {
        this.$validator.validateAll().then(() => {
          if (this.errors.items.length === 0) {
            this.inProgress = true
            this.$http.post(this.$store.state.config.apiURL + '/account/password_reset', this.form).then((response) => {
              this.inProgress = false
              if (response.ok) {
                this.success = 'E-mail for resetting your password sent, please check mail box!'
              }
            }, (response) => {
              this.error = response.body.message
              this.inProgress = false
            })
          }
        })
      },
      back () {
        this.$router.push({name: 'Login'})
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },

      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss">
  .modal-card-foot {
    align-items: center;
    background-color: whitesmoke;
    display: block;
    flex-shrink: 0;
    justify-content: flex-start;
    padding: 20px;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// Forgot.vue?19219f9f